import { Typography, Box} from "@mui/material";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
// import img1 from "../media/img/1.jpg";
// import img2 from "../media/img/2.jpg";
// import img3 from "../media/img/3.JPG";
// import img4 from "../media/img/4.JPG";
// import img5 from "../media/img/5.JPG";

import img1 from "../media/img/1.webp";
import img2 from "../media/img/2.webp";
import img3 from "../media/img/3.webp";
import img4 from "../media/img/4.webp";
import img5 from "../media/img/5.webp";

import Item from "./Item";
import {useRef} from "react";


const Gallery = () => {

    const make = (img, alt) => ({
        original: img,
        thumbnail: img,
        originalAlt: alt,
        thumbnailAlt: alt,
    });

    const images = [
        make(img1, "team members trying to setup the project"),
        make(img2, "an example prototype of rocket of our project"),
        make(img3, "3D printing the project items"),
        make(img4, "This is Luan! He is the society director"),
        make(img5, "2024 event of society"),
    ];


    // const images = [
    //     {
    //         original: img1,
    //         thumbnail: img1,
    //         originalAlt: "team members trying to setup the project",
    //     },
    //     {
    //         original: img2,
    //         thumbnail: img2,
    //         originalAlt: "an example prototype of rocket of our projects",
    //     },
    //     {
    //         original: img3,
    //         thumbnail: img3,
    //         originalAlt: "3D printing the project items",
    //     },
    //     {
    //         original: img4,
    //         thumbnail: img4,
    //         originalAlt: "This is Luan! He is the society director",
    //     },
    //     {
    //         original: img5,
    //         thumbnail: img5,
    //         originalAlt: "2024 event of society",
    //     },
    // ];
    // const matches = useMediaQuery('(min-width:600px)');
    const galleryRef = useRef();
    return (
        <Box sx={{ margin: 2,
            // aspectRatio: "16/9",
            // position: "relative",
            width: "100%",
            // overflow: "hidden",


        }}>
            <Typography variant="h5" sx={{ fontWeight: 600, marginBottom: 2 }}>
                Gallery
            </Typography>
            <ImageGallery
                showPlayButton={false}
                ref={galleryRef}
                renderItem={ (item) =>{
                    console.log(item);
                    const { isFullscreen } = galleryRef.current?.state ?? {};
                    const { onImageError } = galleryRef.current?.props ?? {};
                    const handleImageError =
                        onImageError || galleryRef.current?.handleImageError;

                    return (
                        <Item

                            description={item.description}
                            fullscreen={item.fullscreen}
                            handleImageLoaded={(_) =>{} }
                            isFullscreen={isFullscreen}
                            onImageError={handleImageError}
                            original={item.original}
                            originalAlt={item.originalAlt}
                            originalHeight={item.originalHeight}
                            originalWidth={item.originalWidth}
                            originalTitle={item.originalTitle}
                            sizes={item.sizes}
                            loading={item.loading}
                            srcSet={item.srcSet}
                        />
                    );

                } }
                items={images}

            />

            {/*<ImageList*/}
            {/*    variant="quilted"*/}
            {/*    // cols={{ xs: 2, sm: 3, md: 3 }}*/}
            {/*    // cols={4}*/}
            {/*    cols={matches ? 4 : 2}*/}
            {/*    gap={8}*/}
            {/*>*/}
            {/*    {images.map((src, i) => (*/}
            {/*        <ImageListItem key={i}>*/}
            {/*            <img*/}
            {/*                src={src}*/}
            {/*                alt=""*/}
            {/*                loading="lazy"*/}
            {/*                style={{*/}
            {/*                    // width: "100%",*/}
            {/*                    borderRadius: "8px",*/}
            {/*                }}*/}
            {/*            />*/}
            {/*        </ImageListItem>*/}
            {/*    ))}*/}
            {/*</ImageList>*/}



        </Box>
    );
};

export default Gallery;